import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../store';

export type AppError = {
  name: string
  message: string
  error?: Error
  severity?: 'error' | 'warning' | 'info' | 'success'
};

const initialState: AppError[] = [];

export const snack = createSlice({
  name: 'errors',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    pushError: (state, action: PayloadAction<AppError>) => {
      return [...state, { ...action.payload, severity: 'error' }];
    },
    pushSnack: (state, action: PayloadAction<AppError>) => {
      return [...state, action.payload];
    },
    clearSnacks: () => {
      return initialState;
    },
  },
});

export const snackActions = snack.actions;

export default snack.reducer;

export const selectSnacks = (state: RootState) => state.snacks;
